<template>
  <teleport to="body">
    <div class="debug-modal-backdrop" @click.self="$emit('close')">
      <div class="modal-content" role="dialog" aria-modal="true">
        <!-- Modal de edición/creación -->
        <EditCrudModal
          v-if="showModal"
          :show="showModal"
          :isEdit="!!itemEditando"
          :entityName="titulo.toLowerCase()"
          :item="formItem"
          :showCodigo="esDelegacion"
          :showUsuario="esCategoria"
          :usuarios="usuariosOrdenados"
          :usuarios-cc="usuariosAllOrdenados"
          :campoNombre="campoNombre"
          :showEsCierre="showEsCierre"
          @guardar="guardarItemModal"
          @cancelar="cerrarModal"
        />
        <div class="modal-header">
          <h3 class="modal-title">{{ titulo }}</h3>
          <button
            type="button"
            class="btn-close"
            @click="$emit('close')"
            aria-label="Close"
          >
            <span class="material-icons">close</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="add-btn-row">
            <button
              type="button"
              class="btn-add-crud"
              @click="abrirModal()"
              aria-label="Add"
              :title="$t('añadir_nueva', { entidad: titulo.toLowerCase() })"
            >
              {{ $t('añadir') }} {{ titulo.toLowerCase() }}
            </button>
          </div>
          <div class="table-container full-width-table">
             <table class="table">
              <thead>
                <tr>
                  <th v-if="esDelegacion" style="text-align: center;">{{ $t('codigo') }}</th>
                  <th style="text-align: center;">{{ campoNombre === 'descripcion' ? $t('descripcion') : $t('nombre') }}</th>
                  <th v-if="esCategoria" style="text-align: center;">{{ $t('usuario_asignado') }}</th>
                  <th v-if="esCategoria" style="text-align: center;">{{ $t('notificar_usuario_al_alta') }}</th>
                  <th style="text-align: center;">{{ $t('oculto') }}</th>
                  <th style="text-align: center;">{{ $t('acciones') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in itemsOrdenados" :key="item.id">
                  <td v-if="esDelegacion">{{ item.codigo }}</td>
                  <td>{{ item[campoNombre] || item.nombre }}</td>
                  <td v-if="esCategoria">
                    <input
                      type="text"
                      :value="getUsuarioNombreCompleto(item.id_user_notification)"
                      readonly
                      class="input"
                      style="background: #f8f9fa; border: none; text-align: center;"
                    />
                  </td>
                  <td v-if="esCategoria">
                    <input
                      type="text"
                      :value="getUsuarioNombreCompleto(item.id_user_notification_cc)"
                      readonly
                      class="input"
                      style="background: #f8f9fa; border: none; text-align: center;"
                    />
                  </td>
                  <td style="text-align: center;">
                    <span
                      v-if="item.borrado == 1"
                      :title="$t('oculto')"
                      style="color: #99172A;"
                    >
                      <span class="material-icons">check_circle</span>
                    </span>
                  </td>
                  <td>
                    <span
                      class="icon-action"
                      :title="$t('editar')"
                      @click="abrirModal(item)"
                    >
                      <span class="material-icons action-icon">edit_square</span>
                    </span>
                    <span
                      v-if="item.borrado != 1"
                      class="icon-action"
                      :title="$t('ocultar')"
                      @click="deleteItem(item)"
                    >
                      <span class="material-icons action-icon">visibility_off</span>
                    </span>
                    <span
                      v-else
                      class="icon-action"
                      :title="$t('visualizar')"
                      @click="restoreItem(item)"
                    >
                      <span class="material-icons action-icon">visibility</span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import EditCrudModal from './EditCrudModal.vue';
import api from '../api';
import Swal from 'sweetalert2';

export default {
  components: { EditCrudModal },
  name: 'CrudModal',
  props: {
    titulo: { type: String, default: 'Categorías' },
    endpoint: { type: String, default: '/tickets/todascategorias' },
    esCategoria: { type: Boolean, default: true },
    esDelegacion: { type: Boolean, default: false }
    ,
    campoNombre: { type: String, default: 'nombre' },
    showEsCierre: { type: Boolean, default: false }
  },
  data() {
    return {
      items: [],
      usuarios: [],
      usuariosAll: [],
      showModal: false,
      itemEditando: null,
      formItem: {
        codigo: '',
        nombre: '',
        descripcion: '',
        esCierre: false,
        id_user_notification: '',
        id_user_notification_cc: ''
      },
     isLoading: false,
    };
  },
  mounted() {
    this.loadItems();
    if (this.esCategoria) this.loadUsuarios();
    if (this.esCategoria) this.loadAllUsuarios();
  },
  computed: {
    itemsOrdenados() {
      let arr = [...this.items];
      if (this.esDelegacion) {
        return arr.sort((a, b) =>
          a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' })
        );
      }
      return arr.sort((a, b) =>
        (a[this.campoNombre] || '').localeCompare(b[this.campoNombre] || '', 'es', { sensitivity: 'base' })
      );
    },
    usuariosOrdenados() {
      return [...this.usuarios].sort((a, b) =>
        a.nombre_completo.localeCompare(b.nombre_completo, 'es', { sensitivity: 'base' })
      );
    },
    usuariosAllOrdenados() {
      return [...this.usuariosAll].sort((a, b) =>
        a.nombre_completo.localeCompare(b.nombre_completo, 'es', { sensitivity: 'base' })
      );
    },
  },
  methods: {
    async loadItems() {
      this.isLoading = true;
      try {
        const response = await api.get(this.endpoint);
        const data = response.data.categorias ?? response.data.motivos ?? response.data ?? [];
        this.items = Array.isArray(data) ? data.map(item => ({ ...item, editando: false })) : [];
      } catch (error) {
        if (import.meta.env.DEV) console.error('Error al cargar:', error);
        Swal.fire({ icon: 'error', title: this.$t('error_cargar_registros'), showConfirmButton: false, timer: 2000 });
      } finally {
        this.isLoading = false;
      }
    },
    async loadUsuarios() {
      try {
        const response = await api.get('/usuarios-por-roles');
        this.usuarios = response.data.data ?? [];
      } catch (error) {
        if (import.meta.env.DEV) console.error('Error al cargar los usuarios:', error);
        Swal.fire({ icon: 'error', title: this.$t('error_cargar_usuarios'), showConfirmButton: false, timer: 2000 });
      }
    },
    async loadAllUsuarios() {
      try {
        const response = await api.get('/users');
        this.usuariosAll = response.data.data ?? [];
      } catch (error) {
        if (import.meta.env.DEV) console.error('Error al cargar todos los usuarios:', error);
        // No bloquear al usuario si falla; el select CC usará la lista normal si no se pudo cargar la lista completa.
      }
    },
    updateCategoriaUsuario(item) {
      item.editando = false;
    },
    abrirModal(item = null) {
      if (item) {
        this.itemEditando = item;
        this.formItem = {
          codigo: item.codigo || '',
          nombre: item.nombre || '',
          descripcion: item.descripcion || item.nombre || '',
          esCierre: !!item.esCierre,
          id_user_notification: item.id_user_notification || '',
          id_user_notification_cc: item.id_user_notification_cc || ''
        };
      } else {
        this.itemEditando = null;
        this.formItem = {
          codigo: '',
          nombre: '',
          descripcion: '',
          esCierre: false,
          id_user_notification: '',
          id_user_notification_cc: ''
        };
      }
      this.showModal = true;
    },
    cerrarModal() {
      this.showModal = false;
    },
    async guardarItemModal(item) {
      let payload = {};
      // usar campoNombre si fue configurado
      if (this.campoNombre && this.campoNombre !== 'nombre') {
        payload[this.campoNombre] = item.descripcion || item.nombre;
      } else {
        payload.nombre = item.nombre;
      }
      if (this.showEsCierre) payload.esCierre = !!item.esCierre;
      if (this.esDelegacion) payload.codigo = item.codigo;
      if (this.esCategoria) {
        payload.id_user_notification = item.id_user_notification || null;
        payload.id_user_notification_cc = item.id_user_notification_cc || null;
      }

      if (this.itemEditando) {
        await api.put(
          `${this.endpoint.replace(/\/$/, '')}/${this.itemEditando.id}`,
          payload
        );
        this.itemEditando.nombre = item.nombre;
        if (this.esDelegacion) this.itemEditando.codigo = item.codigo;
          if (this.esCategoria) {
            this.itemEditando.id_user_notification = item.id_user_notification;
            this.itemEditando.id_user_notification_cc = item.id_user_notification_cc;
          }
      } else {
        const response = await api.post(
          this.endpoint.replace(/\/$/, ''),
          payload
        );
        const nuevo =
          response.data.motivo ||
          response.data.categoria ||
          response.data.departamento ||
          response.data.delegacion ||
          response.data;
        this.items.push({
          ...nuevo,
          editando: false
        });
      }
      this.cerrarModal();
      await this.loadItems();
    },
    async guardarItem() {
      let payload = { nombre: this.formItem.nombre };
      if (this.esDelegacion) payload.codigo = this.formItem.codigo;
      if (this.esCategoria) {
        payload.id_user_notification = this.formItem.id_user_notification || null;
        payload.id_user_notification_cc = this.formItem.id_user_notification_cc || null;
      }

      if (this.itemEditando) {
        await api.put(
          `${this.endpoint.replace(/\/$/, '')}/${this.itemEditando.id}`,
          payload
        );
        this.itemEditando.nombre = this.formItem.nombre;
        if (this.esDelegacion) this.itemEditando.codigo = this.formItem.codigo;
          if (this.esCategoria) {
            this.itemEditando.id_user_notification = this.formItem.id_user_notification;
            this.itemEditando.id_user_notification_cc = this.formItem.id_user_notification_cc;
          }
      } else {
        const response = await api.post(
          this.endpoint.replace(/\/$/, ''),
          payload
        );
        const nuevo =
          response.data.categoria ||
          response.data.departamento ||
          response.data.delegacion ||
          response.data;
        this.items.push({
          ...nuevo,
          editando: false
        });
      }
      this.cerrarModal();
      await this.loadItems();
    },
    activarEdicion(item) {
      this.items.forEach(it => (it.editando = false));
      item.editando = true;
    },
    async deleteItem(item) {
      const result = await Swal.fire({
        title: this.$t('confirmar_ocultar', { nombre: item.nombre }),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#99172A',
        cancelButtonColor: '#aaa',
        confirmButtonText: this.$t('si_ocultar'),
        cancelButtonText: this.$t('cancelar')
      });
      if (result.isConfirmed) {
  await api.put(`${this.endpoint.replace(/\/$/, '')}/ocultar/${item.id}`);
        await this.loadItems();
        Swal.fire({
          title: this.$t('ocultado'),
          text: this.$t('registro_oculto'),
          icon: 'success',
          confirmButtonColor: '#99172A'
        });
      }
    },
     async restoreItem(item) {
      const result = await Swal.fire({
        title: this.$t('confirmar_restaurar', { nombre: item.nombre }),
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#2e7d32',
        cancelButtonColor: '#aaa',
        confirmButtonText: this.$t('si_restaurar'),
        cancelButtonText: this.$t('cancelar')
      });
      if (result.isConfirmed) {
        await api.put(`${this.endpoint.replace(/\/$/, '')}/restaurar/${item.id}`);
        await this.loadItems();
        Swal.fire({
          title: this.$t('restaurado'),
          text: this.$t('registro_restaurado'),
          icon: 'success',
          confirmButtonColor: '#2e7d32'
        });
      }
    },
    getUsuarioNombreCompleto(id) {
      if (!id && id !== 0) return '';
      let usuario = this.usuarios.find(u => String(u.id) === String(id));
      if (!usuario) usuario = this.usuariosAll.find(u => String(u.id) === String(id));
      return usuario ? usuario.nombre_completo : '';
    },
  },
};
</script>

<style scoped>
/* Modal de prueba */
.modal-content {
  background-color: #fff;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  width: 700px;
  max-width: 95vw;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  overflow: visible; /* permitir que elementos pos. absolute del header no se recorten */
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 1000;
  max-height: 500px; /* <-- Reduce la altura máxima del modal */
}

.modal-header {
  display: flex;
  justify-content: center; /* centra el título */
  align-items: center;
  position: relative; /* necesario para que el .btn-close absolute se sitúe relativo al header */
  background-color: #99172A;
  color: #fff;
  padding: 12px ; /* espacio lateral para que el título no choque con el botón */
  width: 100%;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  left: 1px;
}

.modal-title {
  font-size: 1.6rem;
  font-weight: bold;
  text-align: center;
  padding: 0;
}

.modal-body {
  padding: 0 28px 28px 28px;
  overflow: visible;
}


/* botón de cierre: colocado dentro del header, centrado verticalmente y siempre visible */
.btn-close {
  background: rgba(0,0,0,0.12);
  border: none;
  cursor: pointer;
  color: #fff;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  opacity: 0.95;
  transition: opacity 0.12s, background-color 0.12s;
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%); /* centra verticalmente respecto al header */
  z-index: 40; /* asegurar por encima de otros elementos */
}
.btn-close:hover {
  opacity: 1;
  background: rgba(0,0,0,0.18);
}

/* icono interno: forzar color y tamaño por si hay reglas globales que lo afecten */
.btn-close .material-icons {
  color: #fff !important;
  font-size: 20px !important;
}


.add-btn-row {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 18px 0 18px 0;
  box-sizing: border-box;
}

.btn-add-crud {
  background-color: #2e7d32 !important; /* Verde oscuro */
  color: #fff !important;
  border: none;
  border-radius: 5px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-bottom: 10px;
}

.btn-add-crud:hover {
  background-color: #1b5e20 !important; /* Verde más oscuro al hover */
  color: #fff !important;
}

.add-icon-red {
  color: inherit;
  font-size: 1.7rem;
  vertical-align: middle;
}

.full-width-table {
  width: 100%;
  padding: 0 0 20px 0;
}

.table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0;
  background: #fff;
}

.table th,
.table td {
  border: 1px solid #ced4da;
  padding: 10px;
  text-align: center;
}

.table th {
  background-color: #f8f9fa;
  font-weight: bold;
  position: sticky;
  top: 0;
  /* z-index eliminado */
}

.icon-action {
  cursor: pointer;
  color: #99172A;
  font-size: 1.5rem;
  display: inline-flex;
  align-items: center;
  margin-right: 8px;
  transition: color 0.2s;
}
.icon-action:last-child {
  margin-right: 0;
}
.icon-action:hover {
  color: #7A1222;
}

/* Mini modal (añadir/editar) */
.mini-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.7); /* opacidad 0.7 */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}
.mini-modal {
  background: #fff;
  border-radius: 12px;
  padding: 2rem 2.5rem;
  min-width: 320px;
  max-width: 95vw;
  box-shadow: 0 2px 12px rgba(0,0,0,0.18);
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  /* z-index eliminado */
}
.mini-modal h4 {
  margin: 0 0 0.5rem 0;
  font-size: 1.2rem;
  color: #99172A;
  font-weight: bold;
  text-align: center;
}
.mini-modal input,
.mini-modal select {
  width: 100%;
  padding: 8px 10px;
  border: 1.5px solid #ced4da;
  border-radius: 5px;
  font-size: 1rem;
  margin-bottom: 10px;
  box-sizing: border-box;
}
.mini-modal-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}
.mini-modal .btn {
  padding: 8px 18px;
  border-radius: 5px;
  border: none;
  font-weight: bold;
  cursor: pointer;
  font-size: 1rem;
  transition: background 0.2s, color 0.2s;
}
.mini-modal .btn-success {
  background: #99172A;
  color: #fff;
}
.mini-modal .btn-success:hover {
  background: #7A1222;
}
.mini-modal .btn-secondary {
  background: #f8f9fa;
  color: #99172A;
  border: 1.5px solid #99172A;
}
.mini-modal .btn-secondary:hover {
  background: #e3e3e3;
  color: #7A1222;
}

.table-container.full-width-table {
  width: 100%;
  max-height: 300px; /* <-- Ajusta la altura máxima de la tabla */
  overflow-y: auto;  /* Scroll solo en la tabla */
  margin-bottom: 20px;
}
</style>

<!-- estilos GLOBALES para el backdrop del CrudModal (no scoped) -->
<style>
.debug-modal-backdrop {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.7); /* opacidad 0.7 */
  z-index: 10000;
  padding: 12px;
  overflow: auto;
}
</style>